import algoliasearch from 'algoliasearch';

export const client = algoliasearch(
  'RG4Q2OFEVQ',
  process.env.REACT_APP_ALGOLIA_API_KEY || '',
);

export const index = client.initIndex('circle_services');
